import { createButtonStyle } from '../styles';
import { useAuthStep } from '../context/AuthStepContext';
import { AuthStep } from '../types';

interface AuthActionButtonProps {
  onClick?: () => void;
}

const AuthActionButton = ({ onClick }: AuthActionButtonProps) => {
  const { currentStep, lastStep } = useAuthStep();

  switch (currentStep) {
    case AuthStep.EMAIL:
      return (
        <button style={createButtonStyle('large')} type="submit">
          Next
        </button>
      );
    case AuthStep.PHONE:
      return (
        <div>
          <button
            style={{ ...createButtonStyle('secondary'), marginRight: '150px' }}
            type="button"
            onClick={lastStep}
          >
            Back
          </button>
          <button
            style={createButtonStyle('small')}
            type="button"
            onClick={onClick}
          >
            Next
          </button>
        </div>
      );
    case AuthStep.PHONE_CODE:
      return (
        <button
          className="btn btnSecondary"
          type="button"
          style={{
            marginLeft: 'auto',
            marginRight: 'auto',
            width: 'fit-content',
            marginTop: '50px',
          }}
          onClick={onClick}
        >
          Back
        </button>
      );
    case AuthStep.PIN:
      return (
        <button
          className="btn btnSecondary"
          style={{
            marginLeft: 'auto',
            marginRight: 'auto',
            width: 'fit-content',
            marginTop: '50px',
          }}
          onClick={onClick}
        >
          Back
        </button>
      );
    default:
      break;
  }
  return (
    <button style={createButtonStyle('large')} type="submit">
      Next
    </button>
  );
};

export default AuthActionButton;
